<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>项目考试</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow: auto;padding: 10px 0;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 83%;margin-left:1%;">
        <el-card style="height:100% !important;" class="aside">
          <div style="display:flex;height：60px;align-items:center;padding:10px;background:#fff" >       
              <el-date-picker
                v-model="date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              ></el-date-picker>
          </div>
          <div class="build-table">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                :cell-style="rowClass"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <!-- <el-table-column label="项目" >
                  <template slot-scope="scope">
                    <a>{{ scope.row.projectName}}</a>
                  </template>
                </el-table-column> -->
                <el-table-column label="在职人数">
                  <template slot-scope="scope">
                    <span>{{ scope.row.zz }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="参加考试(人)">
                  <template slot-scope="scope">
                    <span>{{ scope.row.allNum }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="达标人数" >
                  <template slot-scope="scope">
                    <span>{{ scope.row.qNumber }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="合格分" >
                  <template slot-scope="scope">
                    <span>{{ scope.row.qualified }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="达标率">
                  <template slot-scope="scope">
                    <span>{{ scope.row.rate }}</span>
                  </template>
                </el-table-column>
              </el-table>
          </div>
          <!-- <div style="background:#fff">
             <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3,5, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div> -->
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      listData: [], //表格数据
      dataText: '数据加载中...',
      groupType: '',
      groupId:'',
      date:'',
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      joinType:'',
      dataTree:[],
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      projectId:'',
      currentNodekey:'',
      expandedkeys:[],
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    this.joinType = util.session.get('roleId')=='3'?'3':''
    // this.getData()
    this.getAll()

  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange()
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getPageListPro({
          entId: this.groupId,
          levelType:2
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entOfficeProjectMenu || []
            that.dataTree = list
            console.log(that.dataTree.length)
            if (that.dataTree.length > 0) {
              that.projectId= list[0].list[0].id
              that.currentNodekey = that.dataTree[0].list[0].id
              that.expandedkeys.push(that.dataTree[0].list[0].id)
              that.$nextTick(() => {
                // treeBox 元素的ref   value 绑定的node-key
                that.$refs.tree.setCurrentKey(that.currentNodekey)
              })
              that.getData()
            }else{
              that.dataText = '暂无数据'
            }
            
          }
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      if(data.projectList){
       return
      }else{
       this.projectId=data.id
       this.getData()
      }
      
    },

    // 获取数据
    getData() {
      var that = this
      myHttp.enterprisePaperStatistical({
       date:this.date,
       entId:this.groupId,
       projectId:this.projectId
      }).then(function (resp) {
          if (resp.data.code == '200') {
           console.log(resp)
            var list  = resp.data.data.Paper
            for(var i = 0;i<list.length;i++){
              if(list[i].allNum){
                 list[i].rate =  list[i].rate =(parseInt(list[i].qNumber))/list[i].allNum *100  
              }else{
                list[i].rate = 0
              }
             
            }
            if (list.length == 0) {
              that.dataText = '暂无数据'
            }
            that.listData= list
            // that.totalItems =resp.data.data.qsPageInfo.total
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
     },
    },
   
}
</script>
<style>
  @import '../../assets/css/common.css';
  .el-tree-node__content{
      height: 30px;
  }
  .el-tree-node__label{
    font-size: inherit;
  }
  .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height:calc(100% - 6vh);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
</style>